import "../../utils/tailwind.css";
import { PageProvider, useAddWorkProvider } from "./provider";

import Label from "../../components/label";
import Section from "../../components/section";
import { FormikInput } from "../../components/input";
import Button from "../../components/Buttons";
import { Formik, Form } from "formik";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { initialValues, handleSubmit } = useAddWorkProvider();

  return (
    <Section className="h-[80vh] overflow-y-auto">
      <Label
        label="Add Testimonial Details"
        className="text-[18px] text-black"
      />
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={handleSubmit}>
        {({ values, setFieldValue }) => (
          <Form>
            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2 gap-3">
              <div className="flex flex-col">
                <Label label="Name" className="mb-2 text-black text-[15px]" />
                <FormikInput name="name" rootClassName="w-full" />
              </div>
              <div className="flex flex-col">
                <Label
                  label="Position"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput name="position" rootClassName="w-full" />
              </div>
            </div>
            <div className="w-full mt-3">
              <div className="flex flex-col">
                <Label
                  label="Description"
                  className="mb-2 text-black text-[15px]"
                />
                <FormikInput name="review" rootClassName="w-full" />
              </div>
            </div>
            <div className="fixed bottom-0 left-0 w-full bg-white flex justify-end items-center py-3 pr-4 space-x-3 shadow-md">
              <Button type="submit">Save</Button>
            </div>
          </Form>
        )}
      </Formik>
    </Section>
  );
}
